/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VcdrOrgTypeEnum } from './vcdrOrgTypeEnum';


export interface VcdrOrgProperties { 
    org_type: VcdrOrgTypeEnum;
    /**
     * AWS Account number for VCDR shadow account
     */
    vcdr_shadow_account: string;
    /**
     * Service Instance ID in CSP
     */
    service_instance_id?: string;
    /**
     * VCDR service instance URL registered against given CSP org (typically points to Control Shift FQDN/IP)
     */
    service_instance_url?: string;
}
export namespace VcdrOrgProperties {
}


